import connectionProxy from './connectionProxy'

export const getProductsFispq = (
  page = 1, 
  rowsPerPage = 10, 
  orderBy = "name", 
  order = "asc",
  issue_initial_date = '',
  issue_final_date = '',
  expiration_initial_date = '',
  expiration_final_date = ''
) => {
  let query = `/fispqs?page=${page}&per_page=${rowsPerPage}&order_by=${orderBy}&order=${order}`
  if (issue_initial_date !== '' && issue_final_date !== '') 
    query += `&issue_initial_date=${issue_initial_date}&issue_final_date=${issue_final_date}`
  if (expiration_initial_date !== '' && expiration_final_date !== '') 
    query += `&expiration_initial_date=${expiration_initial_date}&expiration_final_date=${expiration_final_date}`

  return connectionProxy.http.get(query)
  }



// WEBPACK FOOTER //
// ./src/api/fispq.js